import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './@core/aveespa-ui/toast-container/toast-container.component';
import { BadgeService } from './@core/services/utility/badge.service';
import { MobileAppLifecycleService } from './@core/services/utility/mobile-app-lifecycle.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent {
    // Eagerly instantiate so Capacitor listeners are registered at startup.
    private readonly _lifecycle = inject(MobileAppLifecycleService);
    private readonly _badge     = inject(BadgeService);

    constructor() {}
}
